// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { productGridCardStyles } from "@cahaba/Overrides/Widgets/ProductList/ProductListProductGridCard";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productGridCardStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        overflow: hidden;
        border: 1px solid ${getColor("common.border")};
        padding: 10px 25px 10px 25px;
    `,
};

productGridCardStyles.addToListWrapper = {
    css: css`
        text-align: center;
        padding-top: 10px;
    `,
};

productGridCardStyles.addToListLink = {
    link: {
        css: css`
            font-size: 16px;
            font-weight: 600;
        `,
    },
};

productGridCardStyles.parentContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        overflow: hidden;
    `,
};

productGridCardStyles.infoPriceContainer = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

productGridCardStyles.partNumbersStyles = {
    container: {
        css: css`
            flex-shrink: 1;
            flex-grow: 0;
        `,
    },
    erpNumberLabelText: {
        weight: "normal",
        css: css`
            margin-right: 7px;
        `,
    },
    manufacturerItemLabelText: {
        weight: "normal",
        css: css`
            margin-right: 7px;
        `,
    },
};
